import React from 'react';
import PropTypes from 'prop-types';

function Checked({ width, height, color }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 52 52"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="checkmark-circle-2"
          transform="translate(1.000000, 1.000000)"
          fill={color}
          fillRule="nonzero"
          stroke={color}
        >
          <path
            // eslint-disable-next-line max-len
            d="M25,0 C20.0554613,0 15.2219998,1.46622346 11.110769,4.21326263 C6.99952285,6.96029412 3.79521516,10.8647721 1.90302285,15.4329271 C0.0108318515,20.0010821 -0.484250995,25.0276988 0.480379005,29.8772385 C1.44500747,34.7267782 3.82603054,39.1813948 7.32233824,42.6777034 C10.8186152,46.174012 15.2732305,48.5550126 20.122769,49.5196282 C24.9723075,50.4842439 29.9989229,49.9891668 34.5670767,48.0970125 C39.1352305,46.2047812 43.0396921,43.0004727 45.786769,38.8892409 C48.533769,34.778009 50,29.9445462 50,25 C50,21.7169287 49.3533844,18.4660817 48.0969998,15.4329271 C46.8406152,12.3997725 44.9991536,9.64377174 42.6776921,7.32233267 C40.3562305,5.00086284 37.6002305,3.15937774 34.5670767,1.90300819 C31.5339229,0.646644014 28.2830767,0 25,0 Z M35.7499998,19.0250049 L24.3249998,34.0250088 C24.0920767,34.3275474 23.7929998,34.5727013 23.4506921,34.7417013 C23.1083075,34.9107014 22.731769,34.999086 22.3499998,35.0000465 C21.9703075,35.002086 21.5950767,34.9175475 21.2528459,34.7529321 C20.9106152,34.5883167 20.6104613,34.347932 20.3749998,34.0500088 L14.2749998,26.2750068 C14.0730767,26.0156221 13.9242305,25.7190836 13.8369998,25.4021604 C13.7496921,25.0853142 13.7256921,24.7543141 13.7663075,24.4281602 C13.8069229,24.1020063 13.9113844,23.7870062 14.073769,23.5012369 C14.2360767,23.2153906 14.4531536,22.9643906 14.7125382,22.7624674 C15.2363075,22.3546981 15.9006152,22.171775 16.5593844,22.253775 C16.8855382,22.2943904 17.2005382,22.398852 17.4863075,22.5612366 C17.7720767,22.7236213 18.0230767,22.9406213 18.2249998,23.200006 L22.2999998,28.4000074 L31.7499998,15.9000041 C31.9503075,15.6373887 32.2003075,15.4166963 32.4858459,15.2506963 C32.7713844,15.0846962 33.086769,14.9765424 33.4141536,14.9324654 C33.7414613,14.8883116 34.0742305,14.9091577 34.3935382,14.9936193 C34.7128459,15.0781578 35.0123844,15.2247732 35.2749998,15.425004 C35.5376152,15.6252348 35.7583075,15.8753118 35.9243075,16.1608504 C36.0903075,16.4463889 36.1984613,16.7617736 36.2425382,17.0891583 C36.2866921,17.4164661 36.2658459,17.7492354 36.1813844,18.0685432 C36.0968459,18.3878509 35.9502305,18.6873895 35.7499998,18.9500049 L35.7499998,19.0250049 Z"
            id="Shape"
          />
        </g>
      </g>
    </svg>
  );
}

Checked.propTypes = {
  color: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
};

Checked.defaultProps = {
  color: '#7A12D4',
  width: '52px',
  height: '52px',
};

export default Checked;
